module.exports = __webpack_public_path__ + "static/img/9.d7a2b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/9.png
// module id = 1opt
// module chunks = 0